import { Plus, Check } from '@element-plus/icons-vue';
import CompilationsApi from '@/frontend/api/compilations';
import WorksApi from '@/frontend/api/works';
import handlerErrorRequest from '@/frontend/functions/handlerErrorRequest';
import { ElMessage, ElLoading } from 'element-plus';
import buildFormData from '@/common/functions/buildFormData';
export default {
  name: "ProfileCompilationFormPage",
  components: {
    Plus,
    Check
  },

  data() {
    return {
      isNewRecord: this.$route.params.id === undefined,
      form: {
        status_id: '4',
        workIds: [],
        userWorks: [{}]
      },
      title: '',
      shownNextButton: true,
      worksRequestParams: {
        fields: ['id', 'name', 'thumbWithPath', 'author.name'].join(','),
        page: 1,
        'per-page': 9,
        expand: ['author'].join(',')
      },
      works: [],
      worksTab: 'attach',
      worksLoading: false
    };
  },

  methods: {
    removeCustomWork(index) {
      this.form.userWorks.splice(index, 1);
    },

    handlerSelectPhoto(uploadFile) {
      let rawFile = uploadFile.raw;

      if (rawFile.type !== 'image/jpeg' && rawFile.type !== 'image/png') {
        ElMessage.error('Допустимые фото формата JPEG или PNG');
        return false;
      }

      this.form.uploadImage = uploadFile.raw;
      this.form.imageWithPath = URL.createObjectURL(uploadFile.raw);
      return true;
    },

    handlerSelectWorkPhoto(index, uploadFile) {
      this.form.userWorks[index].uploadImage = uploadFile.raw;
      this.form.userWorks[index].thumbWithPath = URL.createObjectURL(uploadFile.raw);
      return true;
    },

    handlerSubmit() {
      let Form = new FormData(),
          loader = ElLoading.service({
        lock: false,
        text: 'Загрузка'
      });
      buildFormData(Form, this.form);
      if (this.isNewRecord) CompilationsApi.create(Form).then(response => {
        ElMessage({
          message: response.message,
          type: 'success'
        });
        this.$router.push({
          name: 'profile/compilations'
        });
      }).catch(handlerErrorRequest).finally(() => {
        loader.close();
      });
      if (!this.isNewRecord) CompilationsApi.update(this.form.id, Form).then(response => {
        ElMessage({
          message: response.message,
          type: 'success'
        });
        this.$router.push({
          name: 'profile/compilations'
        });
      }).catch(handlerErrorRequest).finally(() => {
        loader.close();
      });
    },

    showNext() {
      this.worksRequestParams.page += 1;
      this.requestWorks(true);
    },

    searchWorks(el) {
      this.worksRequestParams.page = 1;
      this.worksRequestParams['filter[or][][workName][like]'] = el.target.value;
      this.worksRequestParams['filter[or][][authorName][like]'] = el.target.value;
      this.requestWorks();
    },

    requestWorks(merge = false) {
      // this.worksLoading = true
      WorksApi.get(this.worksRequestParams).then(response => {
        if (!merge) this.works = response.items;else this.works = this.works.concat(response.items);
        this.shownNextButton = response.items.length >= this.worksRequestParams['per-page'];
      }).catch(error => {
        ElMessage.error('Неизвестная ошибка!');
        console.error(error);
      }); // .finally(() => this.worksLoading = false)
    }

  },

  beforeMount() {
    let loader = ElLoading.service({
      lock: false,
      text: 'Загрузка'
    });
    this.requestWorks();

    if (this.isNewRecord) {
      this.title = 'Создать подборку';
      loader.close();
    } else {
      this.title = 'Редактировать подборку';
      CompilationsApi.get({
        fields: ['id', 'name', 'description', 'thumbWithPath', 'status_id', 'works.id'].join(','),
        expand: ['works', 'userWorks'].join(',')
      }, this.$route.params.id).then(response => {
        this.form.id = response.id;
        this.form.name = response.name || '';
        this.form.description = response.description || '';
        this.form.imageWithPath = response.thumbWithPath || '';
        if (response.status_id === 3) this.form.status_id = response.status_id;
        response.works.forEach(item => this.form.workIds.push(item.id));
        response.userWorks.reverse().forEach(item => this.form.userWorks.unshift(item));
      }).catch(handlerErrorRequest).finally(() => loader.close());
    }
  }

};